// Condividi.tsx — manda il link della sfida (menu di condivisione del telefono, o copia) o il risultato.
import { condividi as condividiNativo } from "../servizi/nativo.ts";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CodiceQR } from "../componenti/CodiceQR.tsx";
import { Finestra } from "../componenti/Finestra.tsx";
import { BASE_API, MARCHIO, PERCORSO_SFIDA } from "../costanti.ts";

const ATTESA_COPIATO_MS = 2000;

/** Indirizzo pubblico del sito: sul web è quello aperto; nelle app native quello dell'API. */
export function indirizzoSito(): string {
  return BASE_API || window.location.origin;
}

export function linkSfida(codice: string): string {
  return `${indirizzoSito()}${PERCORSO_SFIDA}${codice}`;
}

/**
 * v026: il link lungo non si mostra più (al proprietario non serve vederlo): Condividi, Copia e QR. Solo il link
 * personale del profilo (corto, laughdown.net/@nome) resta scritto (`mostraLink`).
 */
export function Condividi({ link, vinto, messaggio, mostraLink = false }: { link: string | null; vinto?: boolean; messaggio?: string; mostraLink?: boolean }) {
  const { t } = useTranslation();
  const [copiato, setCopiato] = useState(false);
  const [qr, setQr] = useState(false);
  const url = link ?? indirizzoSito();
  const testo = messaggio ?? (link ? t("gioco.messaggio_condividi") : vinto ? t("gioco.messaggio_vinto") : t("gioco.messaggio_perso"));

  const copia = async () => {
    try {
      await navigator.clipboard.writeText(link ? `${testo} ${url}` : `${testo} ${url}`);
      setCopiato(true);
      setTimeout(() => setCopiato(false), ATTESA_COPIATO_MS);
    } catch {
      // appunti non disponibili: il link resta visibile da copiare a mano
    }
  };
  const condividi = async () => {
    // v030: nelle app il foglio di condivisione del sistema, nel browser navigator.share; se nessuno dei due, si copia
    if (await condividiNativo({ titolo: MARCHIO, testo, url: url })) return;
    await copia();
  };

  if (!link) {
    return (
      <button type="button" className="pulsante pulsante-piccolo" onClick={() => void condividi()}>
        {copiato ? t("gioco.copiato") : t("gioco.condividi")}
      </button>
    );
  }
  return (
    <div className="condividi">
      {mostraLink ? (
        <p className="condividi-link" translate="no">
          {url}
        </p>
      ) : (
        <span className="condividi-link" hidden data-link={url} />
      )}
      <button type="button" className="ld-cta ld-cta-centrata condividi-principale" onClick={() => void condividi()}>
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="18" cy="5" r="3" />
          <circle cx="6" cy="12" r="3" />
          <circle cx="18" cy="19" r="3" />
          <path d="M8.6 10.6l6.8-4M8.6 13.4l6.8 4" />
        </svg>
        {t("gioco.condividi")}
      </button>
      <div className="ld-invito-secondari">
        <button type="button" className="pulsante" onClick={() => void copia()} aria-live="polite">
          {copiato ? t("gioco.copiato") : t("invito.copia")}
        </button>
        <button type="button" className="pulsante" onClick={() => setQr(true)}>
          {t("invito.qr")}
        </button>
      </div>
      <Finestra aperta={qr} titolo={t("invito.qr_titolo")} onChiudi={() => setQr(false)}>
        <div className="ld-qr-contenitore">{qr && <CodiceQR testo={url} etichetta={t("invito.qr_etichetta")} />}</div>
      </Finestra>
    </div>
  );
}
